var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-10 break-word"},[(_vm.link.url)?_c('a',{staticClass:"bold underline-hover",attrs:{"href":_vm.urlPath,"target":"_blank"}},[_vm._v(_vm._s(_vm.link.url))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }